/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Turn off all Vida level optimize size props for existing content so upgraded content
	* renders similarily after upgrade.
	**/

	class VIDA_OptimizeSizeUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1020;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			/*
			* Cycle through all widgets and, if they are live widgets, upgrade the clipping.
			*/
			_.each(spec.widgets, model => {
				if (model && WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._vidaOptimizeSizeUpgrade(model);
				}
			});
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_vidaOptimizeSizeUpgrade(model) {
			// Turn off optimize size for existing content.
			const optimizeSizePropId = 'optimizeSize';
			const optimizeSizeProp = WidgetUpgradeUtils.findProperty(optimizeSizePropId,model.properties);
			// for network visualization, we have previously set the default value to true but did not save in the model
			// babybi -> endorr1
			const excludedVisId = 'com.ibm.vis.rave2network';
			if (!optimizeSizeProp){
				model.properties.push({
					id: optimizeSizePropId,
					value: model.visId === excludedVisId
				});
			}
		}

	}

	return new VIDA_OptimizeSizeUpgrade();
});
